export const selectLoggedIn = ({ session }) => session.loggedIn;
export const selectShowKycBanner = ({ session }) => session.showKycBanner;
export const selectShowNdlChange = ({ session }) => session.showNdlChange;
export const selectShowDepositLimitConfirmation = ({ session }) => (
  session.depositLimit.showConfirmation
);
export const selectPendingDepositLimit = ({ session }) => session.depositLimit.pendingLimit;
export const selectDepositLimitApi = ({ session }) => session.depositLimit.api;
export const selectCustomerConsentMessages = ({ session }) => session.customerConsentMessages;
